import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

export const FullscreenControl = ():null => {
  const map = useMap();
  const fullscreenControlAdded = useRef(false);

  useEffect(() => {
    // Only add the control if it hasn’t been added yet
    if (!fullscreenControlAdded.current) {
      L.control.fullscreen().addTo(map);
      fullscreenControlAdded.current = true; // Mark as added
    }
  }, [map]);

  return null; // This component only adds the control, nothing to render.
};
